import { IncentiveProgram } from '../CostCalculation/IncentiveProgram';
import { PartnerModel } from '../PartnerModel';
import { UserModel } from '../UserModel';
import { CommunicationType } from '../CommunicationTypes/CommunicationType';

export interface ICustomer {
  trustName: string;
  firstName: string;
  lastName: string;
  middleName: string;
  commercialName: string;
  phoneNumber: number;
  emailAddress: string;
  igsCustomerNumber: string;
  partnerCustomerNumber: string;
  oldPartnerCustomerNumber: string;
  leadNumber: string;
  associatedUtilityName: string;
  associatedRegionName: string;
  partnerCode: string;
  partner: PartnerModel;
  salesPartnerCode: string;
  salesPartner: PartnerModel;
  leadAgentCode: string;
  communicationType: CommunicationType;
  isOriginal62: boolean;
  active: boolean;
  fullName: string;
  incentiveProgram: IncentiveProgram;
  assignedUsers: UserModel[];
  outsideCollections: boolean;
}

export class Customer implements ICustomer {
  public customerId: number;
  public trustName: string;
  public firstName: string;
  public lastName: string;
  public middleName: string;
  public commercialName: string;
  public phoneNumber: number;
  public emailAddress = "";
  public igsCustomerNumber: string;
  public partnerCustomerNumber: string;
  public oldPartnerCustomerNumber: string;
  public leadNumber: string;
  public associatedUtilityName: string;
  public associatedRegionName: string;
  public partnerCode: string;
  public partner: PartnerModel;
  public salesPartnerCode: string;
  public salesPartner: PartnerModel;
  public leadAgentCode: string;
  public communicationType: CommunicationType;
  public isOriginal62: boolean;
  public active: boolean;
  public fullName: string;
  public incentiveProgram: IncentiveProgram;
  public assignedUsers: UserModel[];
  public outsideCollections: boolean;
  public hasContractSigned: boolean;
  public abpAccountNumber: string;
}

export class CustomerInitialized implements ICustomer {
  public customerId = null;
  public trustName = "";
  public firstName = "";
  public lastName = "";
  public middleName = "";
  public commercialName = "";
  public phoneNumber: number;
  public emailAddress = "";
  public igsCustomerNumber = "";
  public partnerCustomerNumber = "";
  public oldPartnerCustomerNumber = "";
  public leadNumber = "";
  public associatedUtilityName = "";
  public associatedRegionName = "";
  public partnerCode = "";
  public partner: PartnerModel;
  public salesPartnerCode = "";
  public salesPartner: PartnerModel;
  public leadAgentCode = "";
  public communicationType: CommunicationType;
  public isOriginal62: boolean;
  public active = true;
  public fullName = "";
  public incentiveProgram: IncentiveProgram;
  public assignedUsers: UserModel[];
  public outsideCollections: boolean;
  public hasContractSigned: boolean;
  public abpAccountNumber: "";
}
